import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree} from '@angular/router';
import {map, Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {take} from 'rxjs/operators';
import {getCurrentUserRecord} from '../store/users/selectors/current-user.selectors';
import {User} from '../models/user.interface';

function isAllowedPermissions(feature: string, mode: string): Observable<boolean | UrlTree> {
  const store: Store = inject<Store>(Store);
  const router: Router = inject(Router);

  const mainPage: UrlTree = router.parseUrl('/');
  const accountPage: UrlTree = router.parseUrl('/account');

  return store.select(getCurrentUserRecord)
    .pipe(
      map((user: User): boolean | UrlTree => {
        const permission: boolean | undefined = user.permissions[feature][mode];
        if (permission) {
          return permission;
        }

        const hasGeneralPermission: boolean | undefined = user.permissions['streams']['read'];
        if (hasGeneralPermission) {
          return mainPage;
        }

        return accountPage;
      }),
      take(1)
    );
}

export const requiredPermissionsGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const feature: string = route.data['feature'] as string;
  const mode: string = route.data['permissionMode'] as string;

  return isAllowedPermissions(feature, mode);
};
